<div class="modal-header">
  <h4 class="modal-title">
    Monthly take home salary preview for {{ employee.firstName }}
    <small class="text-muted">{{ employee.empId }}</small>
  </h4>
  <button
    type="button"
    class="btn-close custom-btn-close"
    data-bs-dismiss="modal"
    aria-label="Close"
    (click)="onClose()"
  >
    <i class="ti ti-x"></i>
  </button>
</div>
<div class="modal-body pb-0">
  <div *ngIf="employee" class="container mt-4">
    <div class="row">
      <!-- Main Payslip Section -->
      <div class="col-md-12">
        <p>
          <strong>Total days in payroll period:</strong>
          {{ totalDaysInPayrollPeriod }} &nbsp;&nbsp; <strong>LOP Days:</strong> 0
        </p>
        <div class="earning-deduction-section">
          <!-- Earnings -->
          <div class="earnings">
            <div>
              <h6 class="pb-3">Earnings</h6>
              <p>
                Basic:
                {{
                  (employeeSalaryDetails?.salaryData?.basic ?? 0) / 12
                    | currency: 'INR' : 'symbol' : '1.2-2'
                }}
              </p>
              <p>
                HRA:
                {{
                  (employeeSalaryDetails?.salaryData?.hra ?? 0) / 12
                    | currency: 'INR' : 'symbol' : '1.2-2'
                }}
              </p>
              <ng-container *ngFor="let item of employeeSalaryDetails?.salaryData?.otherComponents">
                <p *ngIf="item.componentType !== 'customDeductions'">
                  {{ item.name }}:
                  {{ (item.employerContribution ?? 0) / 12 | currency: 'INR' : 'symbol' : '1.2-2' }}
                </p>
                <ng-template #elseBlock>
                  <p>
                    {{ item.name }} - Employer Contribution:
                    {{
                      (item.employerContribution ?? 0) / 12 | currency: 'INR' : 'symbol' : '1.2-2'
                    }}
                  </p>
                  <p>
                    {{ item.name }} - Employee Contribution:
                    {{
                      (item.employeeContribution ?? 0) / 12 | currency: 'INR' : 'symbol' : '1.2-2'
                    }}
                  </p>
                </ng-template>
              </ng-container>
              <p>
                Special Allowances:
                {{
                  (employeeSalaryDetails?.salaryData?.specialAllowance ?? 0) / 12
                    | currency: 'INR' : 'symbol' : '1.2-2'
                }}
              </p>
            </div>
            <div class="totals-row">
              <span
                >Total Earnings:
                {{ monthlyTotalEarnings | currency: 'INR' : 'symbol' : '1.2-2' }}</span
              >
            </div>
          </div>

          <!-- Deductions -->
          <div class="deductions">
            <div>
              <h6 class="pb-3">Deductions</h6>
              <p>
                Pf:
                {{
                  (employeeSalaryDetails?.salaryData?.pf ?? 0) / 12
                    | currency: 'INR' : 'symbol' : '1.2-2'
                }}
              </p>
              <ng-container *ngFor="let item of employeeSalaryDetails?.salaryData?.otherComponents">
                <ng-container *ngIf="item.componentType === 'customDeductions'">
                  <p>
                    {{ item.name }} - Employer Contribution: ₹{{
                      (item.employerContribution ?? 0) / 12 | currency: 'INR' : 'symbol' : '1.2-2'
                    }}
                  </p>
                  <p>
                    {{ item.name }} - Employee Contribution: ₹{{
                      (item.employeeContribution ?? 0) / 12 | currency: 'INR' : 'symbol' : '1.2-2'
                    }}
                  </p>
                </ng-container>
              </ng-container>
            </div>
            <div class="totals-row text-end">
              <span
                >Total Deductions:
                {{ monthlyTotalDeductions | currency: 'INR' : 'symbol' : '1.2-2' }}</span
              >
            </div>
          </div>
        </div>

        <h5 class="mt-5">
          Net Salary<span class="text-danger">*</span>
          {{ monthlyTotalEarnings - monthlyTotalDeductions | currency: 'INR' : 'symbol' : '1.2-2' }}
          <small class="text-muted">/month</small>
        </h5>
        <p class="text-muted small">
          <span class="text-danger">*</span> This is just for information purpose only, actual
          values may differ based on payroll input, investment declarations by employee or any
          change in previous income declaration
        </p>
      </div>

      <!-- Settings and Assumptions Section -->
      <!--<div class="col-md-5">
          <div class="settings-scroll border p-3">
            <h6>Settings and Assumptions</h6>
            <p class="text-muted small">
              Feel free to play around without any worry because any settings changes won’t be saved
            </p>

            <div>
              <h6 class="pb-3">Payroll Inputs <a href="#">✏️ Edit</a></h6>
              <p><strong>Period:</strong> 01 Mar - 31 Mar, 2025</p>
              <p><strong>LOP Days:</strong> 0 day(s)</p>
              <p><strong>Bonus:</strong> ₹0.00</p>
              <p><strong>Leave Travel Allowance:</strong> ₹0.00</p>
              <p><strong>Commission:</strong> ₹0.00</p>
            </div>

            <div>
              <h6 class="py-3">Investment Declarations</h6>
              <p>Section 10: ₹0.00</p>
              <p>Section 80C: ₹0.00</p>
              <p>Section 80D: ₹0.00</p>
              <p>Section 80E: ₹0.00</p>
              <a href="#">View More ...</a>
            </div>
          </div>
        </div>-->
    </div>
  </div>
</div>
<div class="modal-footer">
  <!--<button
        type="button"
        class="btn btn-white border me-2"
        data-bs-dismiss="modal"
        (click)="onClose()"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        (click)="onFamilySubmit()"
        [disabled]="!personalform.valid"
      >
        Save
      </button>-->
</div>
